import { useLocation } from "wouter";
import { resolveSiteRequest } from "@shared/siteRoutes";
import { useSEO } from "@/hooks/useSEO";

export default function RouteSEO() {
  const [location] = useLocation();
  useSEO(resolveSiteRequest(location).fallbackSEO);
  return null;
}
